import { getLoyaltyPurchasePointsOffersKey } from 'actions/loyalty/fetchLoyaltyPurchasePointsOffers'
import { clearCheckoutCart, initialiseCheckout } from 'actions/CheckoutActions'
import { pushWithRegion } from 'actions/NavigationActions'
import { getCurrentIntl } from 'i18n/util/currentIntl'
import { generateLoyaltyPurchasePointsItem } from 'lib/checkout/loyaltyPurchasePoints/cart'
import { getCheckoutPathWithCartId } from 'lib/url/pathsUtils'
import { showSnackbar } from 'LuxKit/Snackbar/AppSnackbar'
import { getCurrentUserId, selectLoggedIn } from 'selectors/accountSelectors'
import type { AppAction } from 'actions/types/ActionTypes'

function pickOfferFromState(
  state: App.State,
  offerId: string,
): App.LoyaltyPurchasePointsOffer | undefined {
  const isLoggedIn = selectLoggedIn(state)
  const customerId = isLoggedIn ? getCurrentUserId(state) : undefined
  const currency = state.geo.currentCurrency
  const key = getLoyaltyPurchasePointsOffersKey(currency, customerId)
  return state.loyalty.purchaseOffers[key]?.data?.find(offer => offer.id === offerId)
}

function showInitialiseFailureSnackbar(): void {
  const intl = getCurrentIntl()
  showSnackbar(
    intl.formatMessage({
      id: 'FT1rED1N0OMOw2qZO3Nr',
      defaultMessage: 'We couldn’t start your purchase right now. Please try again.',
      description: 'Snackbar body shown when starting the Société Buy Points checkout fails (offer unavailable or cart could not be initialised)',
    }),
    'critical',
    {
      heading: intl.formatMessage({
        id: 'lxQAh5Pqwmy5urTkaIHI',
        defaultMessage: 'Something went wrong',
        description: 'Snackbar heading shown when starting the Société Buy Points checkout fails',
      }),
    },
  )
}

/**
 * Bootstraps a single-item Société Buy Points checkout from the landing page.
 * Snapshots the offer to a cart item; svc-order mints the PENDING purchase
 * record server-side when the cart syncs, populating `purchaseRecordId`.
 */
function initialiseLoyaltyPurchasePointsCheckout(offerId: string): AppAction {
  return function(dispatch, getState) {
    const offer = pickOfferFromState(getState(), offerId)
    if (!offer) {
      showInitialiseFailureSnackbar()
      return
    }

    dispatch(clearCheckoutCart())

    const item = generateLoyaltyPurchasePointsItem(offer)

    dispatch(initialiseCheckout([item]))

    const cartId = getState().checkout.cart.cartId
    if (!cartId) {
      showInitialiseFailureSnackbar()
      return
    }
    dispatch(pushWithRegion(getCheckoutPathWithCartId('purchase', cartId)))
  }
}

export default initialiseLoyaltyPurchasePointsCheckout
